import bodybuilder from 'bodybuilder'
import * as Form from '../../../components/form'
import * as Elasticsearch from '../../../elasticsearch'
import * as ReportUtils from '../utils'
import * as Constants from './constants'
import * as Types from './types'

export const fetchOtherClicksFunction = (event: string, max: number) =>
(community: string, form: Types.FormState) => {
  return Elasticsearch.createEsSearch(event)(
    community,
    Elasticsearch.Indexes.EmailActions,
    bodybuilder().size(0)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
      community)
    .filter(
      'range',
      Elasticsearch.DocumentFieldNames.MessageSendDate,
      ReportUtils.searchDateRange(form))
    .filter(
      'term',
      Elasticsearch.DocumentFieldNames.IncludeInReports,
      true)
    .filter(
      'term',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
      Elasticsearch.EmailActionFieldSegments.Click)
    .notFilter(
      'exists',
      Elasticsearch.DocumentFieldNames.PostSubscriptionId)
    .notFilter(
      'exists',
      Elasticsearch.DocumentFieldNames.CommunityPromotionId,
    )
    .aggregation(
      'terms',
      Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.NormalizedClickUrl),
      {
        size: max,
      },
      Elasticsearch.DocumentFieldNames.ClickedURL,
      (byClicks: any) => byClicks.aggregation(
        'cardinality',
        Elasticsearch.DocumentFieldNames.CommunityPersonId,
        Elasticsearch.AggFieldNames.UniqueCount,
      ).aggregation(
        'terms',
        Elasticsearch.DocumentFieldNames.SuspectClick,
        Elasticsearch.DocumentFieldNames.SuspectClick,
        (suspectClickTypes: any) => suspectClickTypes.aggregation(
          'cardinality',
          Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.CommunityPersonGuid),
          Elasticsearch.AggFieldNames.UniqueCount,
          {
            precision_threshold: 40000,
          },
        ),
      ),
    )
    .build(),
  )
}

export const fetchOtherClicks =
  fetchOtherClicksFunction(Constants.FETCH_OTHER_CLICKS, Constants.NUM_OTHER_CLICKS)

export const FormActions = Form.createActionsMap(Constants.OTHER_CLICKS_FILTER)



// WEBPACK FOOTER //
// ./src/pages/reports/other-clicks/actions.ts